import React from "react";
import { useQuery } from "@apollo/client";
import { useHistory } from "Hooks/useRouter";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import queries from "Shared/queries";
import {
  GetLatestPayrollAnomaliesCountQuery,
  GetLatestPayrollAnomaliesCountQueryVariables
} from "generated/graphql";
import SupplementaryInfo from "../../CalloutCard/SupplementaryInfo/SupplementaryInfo";

export const AnomaliesSupplementaryInfo = () => {
  const history = useHistory();
  const { data, loading, error } = useQuery<
    GetLatestPayrollAnomaliesCountQuery,
    GetLatestPayrollAnomaliesCountQueryVariables
  >(queries.GET_LATEST_PAYROLL_ANOMALIES_COUNT);

  if (
    loading ||
    error ||
    !data?.payrollJournalFiles?.items[0]?.supportsAnomalyReport ||
    !data?.payrollJournalFiles?.items[0]?.anomalyReport?.outliers
  ) {
    return null;
  }

  const anomaliesCount = data?.payrollJournalFiles?.items[0].anomalyReport?.outliers.totalCount;
  const anomaliesText = anomaliesCount === 1 ? "1 Anomaly" : `${anomaliesCount} Anomalies`;
  const id = data?.payrollJournalFiles?.items[0].id;

  const goToReport = () => {
    history.push({
      pathname: InternalRoutes.netEarningsAnomalyReport.replace(":id", id)
    });
  };

  return (
    <SupplementaryInfo
      pendingCount={anomaliesCount}
      text={anomaliesText}
      onClick={goToReport}
    />
  );
};
